import {gql} from '@apollo/client';
import {useMutation} from '@apollo/client/react';
import { useAuthContext } from '@/context/AuthContext';

const DELETE_EXPENSE_REPORT = gql`
  mutation DeleteExpenseReport($uuid: ID!) {
    deleteExpenseReport(deletedExpenseReport: { uuid: $uuid })
  }
`;

export const useDeleteExpenseReport = () => {

  const [deleteExpenseReportMutation, { loading, error, data }] = useMutation(DELETE_EXPENSE_REPORT, {

  });

  const deleteExpenseReport = async (uuid) => {
    const response = await deleteExpenseReportMutation({
      variables: { uuid },
    });
    return response.data.deleteExpenseReport;
  };

  return { deleteExpenseReport, loading, error, data };
};
